export const formatQty = (value) => Number(value || 0).toFixed(2);

export const TODAY_QTY_SUMMARY_COLUMNS = [
  { key: 'customer', label: 'Customer' },
  { key: 'site', label: 'Site' },
  { key: 'grade', label: 'Grade' },
  { key: 'dcQty', label: 'DC Qty', align: 'right' },
  { key: 'acceptedQty', label: 'Accepted Qty', align: 'right' },
  { key: 'loadCount', label: 'No. of Load', align: 'right' },
  { key: 'marketing', label: 'Marketing' },
];

export function mapDeliveryChallanForTodayQty(dc) {
  const salesOrder = dc.work_schedule?.sales_order_detail?.sales_order;
  const isActive = dc.status === true || dc.status === 1;
  return {
    id: dc.id,
    delivery_challan_date: dc.delivery_challan_date,
    customer: salesOrder?.consignee?.customer?.name || '-',
    site: salesOrder?.consignee?.project_name || '-',
    grade: dc.work_schedule?.sales_order_detail?.product?.name || '-',
    dc_qty: Number(dc.dc_qty) || 0,
    accepted_qty: Number(dc.accepted_qty) || 0,
    marketing: salesOrder?.consignee?.customer?.salesrep?.name || '-',
    is_inactive: !isActive,
  };
}

export function buildTodayQtySummaryRows(records) {
  const groups = new Map();

  (records || []).forEach((row) => {
    if (row.is_inactive) {
      return;
    }
    const customer = row.customer || '-';
    const site = row.site || '-';
    const grade = row.grade || '-';
    const marketing = row.marketing || '-';
    const key = `${customer}|${site}|${grade}|${marketing}`;
    const dcQty = Number(row.dc_qty) || 0;
    const acceptedQty = Number(row.accepted_qty) || 0;

    if (!groups.has(key)) {
      groups.set(key, {
        customer,
        site,
        grade,
        marketing,
        dcQty: 0,
        acceptedQty: 0,
        loadCount: 0,
      });
    }

    const group = groups.get(key);
    group.dcQty += dcQty;
    group.acceptedQty += acceptedQty;
    group.loadCount += 1;
  });

  return Array.from(groups.values()).sort((left, right) => (
    left.customer.localeCompare(right.customer)
    || left.site.localeCompare(right.site)
    || left.grade.localeCompare(right.grade)
    || left.marketing.localeCompare(right.marketing)
  ));
}

export function formatTodayQtySummaryDisplayRows(summaryRows) {
  return (summaryRows || []).map((row) => ({
    customer: row.customer,
    site: row.site,
    grade: row.grade,
    dcQty: formatQty(row.dcQty),
    acceptedQty: formatQty(row.acceptedQty),
    loadCount: row.loadCount,
    marketing: row.marketing,
  }));
}

export function buildTodayQtySummaryTotals(summaryRows) {
  return (summaryRows || []).reduce(
    (totals, row) => ({
      dcQty: totals.dcQty + (Number(row.dcQty) || 0),
      acceptedQty: totals.acceptedQty + (Number(row.acceptedQty) || 0),
      loadCount: totals.loadCount + (Number(row.loadCount) || 0),
    }),
    { dcQty: 0, acceptedQty: 0, loadCount: 0 },
  );
}
